import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ExcelIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M27.2382 9.98535C28.3581 9.99792 29.914 10.0033 31.2336 9.99792C31.9092 9.99612 32.252 9.11622 31.7844 8.58469C30.9374 7.62578 29.7576 6.28798 28.5728 4.94478C27.383 3.5962 26.1882 2.24223 25.3196 1.25818C24.8387 0.714081 24 1.08759 24 1.84179V6.45498C24 8.39076 25.4627 9.98535 27.2382 9.98535Z'
      fill='#207546'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21.8388 22.7743C22.3693 23.3154 22.3693 24.1927 21.8388 24.7338C21.3082 25.275 20.4481 25.275 19.9176 24.7338L18 22.7761L16.0807 24.7357C15.8163 25.0053 15.4687 25.1402 15.121 25.1402C14.7733 25.1402 14.4257 25.0053 14.1612 24.7357C13.6307 24.1945 13.6307 23.3173 14.1612 22.7761L16.0807 20.8184L14.1594 18.8588C13.6289 18.3177 13.6289 17.4404 14.1594 16.8992C14.6901 16.3581 15.5483 16.3581 16.0789 16.8992L18 18.8588L19.9194 16.9011C20.4499 16.3599 21.31 16.3599 21.8406 16.9011C22.3711 17.4422 22.3711 18.3195 21.8406 18.8607L19.9212 20.8184L21.8388 22.7743ZM32.2141 12.6366H26.849C23.6531 12.6181 21.0131 9.91792 21.0131 6.62488V0.829264C21.0131 0.378617 20.6636 0 20.2109 0H10.8802C6.52908 0 3 3.65504 3 8.11903V27.5227C3 32.2027 6.70472 36 11.246 36H25.1379C29.4872 36 33 32.3819 33 27.9179V13.4474C33 12.9967 32.6505 12.6366 32.2141 12.6366Z'
      fill='#207546'
    />
  </SvgIcon>
);

export default ExcelIcon;
